import { useQuery } from "@tanstack/react-query";
import client from "../api/sanity_client";

async function getProjects() {
  const res = await client.fetch(
    `*[_type == "project"] | order(_updatedAt desc) {
        _id,
        course,
        title,
        projectSummary,
        video,
        tags,
        students,
        instructors,
        partner,
        mentor,
        semester,
        poster {
          asset-> {
            _id,
            url
          }
        },
        previewImage {
          asset-> {
            _id,
            url
          }
        },
        affiliation
      }`
  );
  // const res = await fetch("/api/projects/route");
  // const data = await res.json();
  // return data;
  return res;
}

export default function useGetProjects() {
  const { data: projects, isLoading: isLoadingProjects } = useQuery({
    queryKey: ["allProjects"],
    queryFn: () => getProjects(),
  });

  return { projects, isLoadingProjects };
}
